import { Component, ViewChild, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { NgForm, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { ProveedorSimple } from '../../../productos/modificacion-precio/proovedor-simple.model';
import { Role } from '../../../security/role/role.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from '../../../shared-services/navigation.service';
import { HttpClient } from '@angular/common/http';
import { SnackService } from '../../../shared-services/snack.service';
import { BackendService } from '../../../core/backend.service';
import { SecurityService } from '../../../security/security.service';
import { Producto } from '../../../productos/producto.model';


@Component({
  selector: 'app-costo-envio-massive',
  templateUrl: './costo-envio-massive.component.html',
  styleUrls: ['./costo-envio-massive.component.scss']
})
export class CostoEnvioMassiveComponent implements OnInit {
  @ViewChild('UploadFileInput') uploadFileInput: ElementRef;
  fileUploadForm: FormGroup;
  fileInputLabel: string;

  paisSeleccionado: string;
  user: any;
  rol: Role;

  constructor(
    private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService,
    protected router: Router,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private snackService: SnackService,
    private backendService: BackendService,
    private authService: SecurityService
  ) {}

  ngOnInit() {
    this.user = this.authService.user;
    this.fileUploadForm = this.formBuilder.group({
      myfile: ['']
    });
  }

  onPaisSelect(event) {
    console.log(event.value);
    this.paisSeleccionado = event.value;
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.fileInputLabel = file.name;
      this.fileUploadForm.get('myfile').setValue(file);
    }
  }

  async onFormSubmit() {
    if (!this.fileUploadForm.get('myfile').value) {
      this.snackService.warn('Por favor, seleccione un archivo válido');
      return false;
    }

    const formData = new FormData();
    formData.append('file', this.fileUploadForm.get('myfile').value);

    this.snackService.spinner(true);
    try {
      await this.backendService.createFile('/costo-envio/update/' + this.paisSeleccionado, formData);
      //await this.backendService.createFile('/provincia-chile/direcciones-chile', formData);
      //this.snackService.success('Direcciones agregadas correctamente');
      this.snackService.success('Costos de envios agregados satisfactoriamente');
      this.router.navigate(['/costos-envio']);
    } catch (ex) {
      if (ex[0]) {
        this.snackService.error(ex[0].details);
      } else if (ex.errors) {
        this.snackService.error(ex.errors[0].defaultMessage);
      } else {
        this.snackService.error(ex.message);
      }
    } finally {
      this.snackService.spinner(false);
    }
  }

  back() {
    this.router.navigate(['/costos-envio']);
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

}


// WEBPACK FOOTER //
// ./src/app/pedido/costo-envio/costo-envio-massive/costo-envio-massive.component.ts